// @flow

import React from 'react';
import {getRowData} from './utils';

import type {StatelessFunctionalComponent} from 'react';

/**
 * Head component Props
 */
type HeadProps = {|
    children: React$Node,
    /**
     * Custom header height
     */
    height?: number,
    /**
     * Mix for Head
     */
    mix?: string,
|};

export const Head: StatelessFunctionalComponent<HeadProps> = props => {
    const {children, wrappedCells} = getRowData(props);
    const {mix = ''} = props;
    return (
        <thead className={mix}>
            {children}
            {wrappedCells}
        </thead>
    );
};
